import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// The HTML prerendered by react-snap (for search engines and first paint) already holds the
// Firestore content, while the app's first render shows loading states: hydrating it always
// mismatched (React errors #418/#423) and fell back to a full client render anyway.
// createRoot replaces the prerendered markup directly.
const container = document.getElementById('root');
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
